import React from 'react';
import ReactDOM from 'react-dom/client'; // Use createRoot from 'react-dom/client'
import App from './App';
import "./index.css";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

// Disable React DevTools in production
if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

// Find the root element in your HTML
const rootElement = document.getElementById('root');

// Create a root for React 18 rendering
const root = ReactDOM.createRoot(rootElement);

// Render the app using the root created
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
